<template>
    <div>
        <div class="mb-10">
            <h1 class="text-white font-thin text-center text-3xl md:text-5xl">Smart Music <sup class="text-sm text-nomad-accent">beta</sup></h1>
            <p class="block text-white font-thin text-center">Unlocking the Future of Music Playback</p>
            <p class="block text-white font-thin text-center">Discover Smart Music: Transforming songs costs us on average $0.24. Explore our current collection and <a href="https://www.buymeacoffee.com/kaym.dev" target="_blank" class="text-nomad-accent font-bold">support us</a> to expand Our playlist!</p>
        </div>
        <div>
            <ul class="grid md:grid-cols-2 gap-3">
                <li v-for="song in songs.data">
                    <card-song :song="song" />
                </li>
            </ul>
        </div>
        <div v-if="songs">
            <ul class="flex">
                <li v-if="songs.prev_page_url"><Link :to="songs.prev_page_url" class="text-nomad-accent rounded-md border border-nomad-accent hover:bg-nomad-accent hover:text-nomad-900">prev</Link></li>
                <li v-if="songs.next_page_url"><Link :to="songs.next_page_url" class="text-nomad-accent rounded-md border border-nomad-accent hover:bg-nomad-accent hover:text-nomad-900">next</Link></li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { Link } from "@inertiajs/vue3";
import CardSong from "@/components/CardSong.vue";
defineProps({ songs: Object });
</script>